<template>
  <div class="detail" v-show="!showOverviewTableExample">
    <div class="heading">検討開始 / リリース</div>
        <div class="content">{{ startYear }}年{{ startMonth }}月 / {{ launchYear }}年{{ launchMonth }}月</div>
    <div class="heading">概算必要資金</div>
    <div class="content">{{ currencyFormat(operatingMoney, 0) }}円</div>
    <div class="heading">単月黒字</div>
    <table>
      <tr>
        <th>達成時期</th>
        <td>{{ surplusDate }}（{{ surplusMonth }}）</td>
      </tr>
      <tr>
        <th>単月売上</th>
        <td>{{ currencyFormat(surplusMonthSales, 0) }}円</td>
      </tr>
      <tr>
        <th>単月販売数</th>
        <td>{{ currencyFormat(surplusMonthSellVolume, 0) }}件</td>
      </tr>
    </table>
    <div class="heading">累損解消</div>
    <table>
      <tr>
        <th>達成時期</th>
        <td>{{ cumulativeSurplusDate }}（{{ cumulativeSurplusMonth }}）</td>
      </tr>
      <tr>
        <th>累積売上</th>
        <td>{{ currencyFormat(cumulativeSurplusMonthSales, 0) }}円</td>
      </tr>
      <tr>
        <th>累積販売数</th>
        <td>{{ currencyFormat(cumulativeSurplusMonthSellVolume, 0) }}件</td>
      </tr>
    </table>
  </div>
</template>

<script>
  import _ from 'lodash'
  import VueTypes from 'vue-types'
  import PL from './profit-and-loss'

  export default {
    mixins: [PL],

    name: 'ProfitAndLossOverviewTable',

    props: {
      showOverviewTableExample: VueTypes.bool.def(false)
    },

    data () {
      return {}
    },

    computed: {

      // 単月黒字

      surplusDate () {
        const d = this._startDate().add({ month: _.toInteger(this.findSurplusMonthForFunds()) }).format('YYYY年MM月')
        return d === 'Invalid date' ? '' : d
      },

      surplusMonth () {
        let month = this.findSurplusMonthForFunds()
        if (month !== null) {
          return `${month + 1}ヶ月後`
        } else {
          return ''
        }
      },

      surplusMonthSales () {
        let month = this.findSurplusMonthForFunds()
        if (month !== null) {
          if (month < this.beforeMonths) {
            return this.beforeTotalSalesInMonth(month)
          } else {
            month = month - this.beforeMonths
            if (month < 12) {
              return this.year1TotalSalesInMonth(month)
            } else if (month < 24) {
              return this.year2TotalSalesInMonth(month - 12)
            } else if (month < 36) {
              return this.year3TotalSalesInMonth(month - 24)
            } else {
              // illegal
              return ''
            }
          }
        } else {
          return ''
        }
      },

      surplusMonthSellVolume () {
        let month = this.findSurplusMonthForFunds()
        if (month !== null) {
          if (month < this.beforeMonths) {
            return 0
          } else {
            month = month - this.beforeMonths
            if (month < 12) {
              return this.year1MainSellVolumeInMonth(month) + this.year1SubSellVolumeInMonth(month)
            } else if (month < 24) {
              return this.year2MainSellVolumeInMonth(month - 12) + this.year2SubSellVolumeInMonth(month - 12)
            } else if (month < 36) {
              return this.year3MainSellVolumeInMonth(month - 24) + this.year3SubSellVolumeInMonth(month - 24)
            } else {
              // illegal
              return ''
            }
          }
        } else {
          return ''
        }
      },

      surplusMonthOperatingProfit () {
        let month = this.findSurplusMonthForFunds()
        if (month !== null) {
          if (month < this.beforeMonths) {
            return this.beforeOperatingProfitTotalInMonthForFunds(month)
          } else {
            month = month - this.beforeMonths
            if (month < 12) {
              return this.year1OperatingProfitTotalInMonthForFunds(month)
            } else if (month < 24) {
              return this.year2OperatingProfitTotalInMonthForFunds(month - 12)
            } else if (month < 36) {
              return this.year3OperatingProfitTotalInMonthForFunds(month - 24)
            } else {
              // illegal
              return ''
            }
          }
        } else {
          return ''
        }
      },

      // 累積黒字

      cumulativeSurplusDate () {
        const d = this._startDate().add({ month: _.toInteger(this.findCumulativeSurplusMonthForFunds()) }).format('YYYY年MM月')
        return d === 'Invalid date' ? '' : d
      },

      cumulativeSurplusMonth () {
        let month = this.findCumulativeSurplusMonthForFunds()
        if (month !== null) {
          return `${month + 1}ヶ月後`
        } else {
          return ''
        }
      },

      cumulativeSurplusMonthSales () {
        let month = this.findCumulativeSurplusMonthForFunds()
        if (month !== null) {
          return _.sum(_.take(this.salesPerMonths(), month + 1))
        } else {
          return ''
        }
      },

      cumulativeSurplusMonthSellVolume () {
        let month = this.findCumulativeSurplusMonthForFunds()
        if (month !== null) {
          return _.sum(_.take(this.sellVolumesPerMonths(), month + 1))
        } else {
          return ''
        }
      },

      cumulativeSurplusMonthOperatingProfit () {
        let month = this.findCumulativeSurplusMonthForFunds()
        if (month !== null) {
          return _.sum(_.take(this.operatingProfitsPerMonthsForFunds(), month + 1))
        } else {
          return ''
        }
      },

      // 運転資金
      // 最大累積赤字
      operatingMoney () {
        let month = this.findCumulativeMaxShortageMonthForFunds()
        if (month != null) {
          // 累積赤字の最大
          return Math.abs(_.sum(_.take(this.operatingProfitsPerMonthsForFunds(), month + 1)))
        } else {
          return ''
        }
      }

    },

    methods: {

      toSigned (val) {
        if (val >= 0 || isNaN(val)) {
          return val.toFixed(1)
        } else {
          return this.negativeMark + ' ' + Math.abs(val).toFixed(1)
        }
      },

      percentage (dividend, divisor) {
        if (_.toInteger(divisor) === 0) {
          return 0
        } else {
          return dividend / divisor * 100
        }
      },
    }
  }
</script>
